<div nz-row class="d-flex align-i-c " nz-row [nzGutter]="15">
    <div nz-col nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="8" nzXl="10">
        <h1 class="page-title-text"> Program Periods</h1>
    </div>
    <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="16" nzXl="14" class="mt-ipad-2">
        <div class="d-flex justify-content-end">
            <div class="mr-1 header-select select-box-width" *ngIf="!isInvestmentModal">
                <nz-select [(ngModel)]="selectedFilter" nzShowSearch (ngModelChange)="stautusFilter($event)"
                    [nzSelectOnTab]="true">
                    <nz-option [nzValue]="2" nzLabel="All"></nz-option>
                    <nz-option [nzValue]="1" nzLabel="Visible"></nz-option>
                    <nz-option [nzValue]="0" nzLabel="Hidden"></nz-option>
                </nz-select>
            </div>
            <div class="mr-1 select-box-width">
                <nz-form-control nzErrorTip="Please input your username!">
                    <nz-input-group nzPrefixIcon="search" class="search-input">
                        <input [(ngModel)]="searchText" (keyup)="searchPorgram($event)" nz-input
                            placeholder="Search here..." />
                    </nz-input-group>
                </nz-form-control>
            </div>
            <div *ngIf="canAddProgram">
                <button nz-button class="addButton medium-btn" (click)="showProgramDrawer(null)" nzType="primary">
                    <i nz-icon nzType="plus" nzTheme="outline"></i>
                    New
                </button>
            </div>
        </div>
    </div>
</div>
<div nz-row>
    <div nz-col nzSpan="24" class="section-top-padding">
        <nz-table [nzPageSize]="pageSize" [nzOuterBordered]="true" [nzFrontPagination]="false"
            [nzShowPagination]="totalRecords > 10" [(nzPageIndex)]="page" [nzTotal]="totalRecords"
            (nzPageIndexChange)="onQueryParamsChange($event)" [nzHideOnSinglePage]="true" [nzData]="apiProgramsData"
            #apiProgramsDataTable nzTableLayout="fixed"
            [nzScroll]="apiProgramsData.length > 0 ? showActions ? {x:'1500px', y: 'calc(100vh - 21em)'} :  {x:'1500px',y: 'calc(100vh - 29em)'} : {}">
            <thead>
                <tr>
                    <ng-container *ngFor="let col of colsPrograms;let i=index">
                        <th *ngIf="col.width && col.title != 'Action'" nz-resizable nzBounds="window"
                            [nzColumnKey]="col.sortTitle" nzPreview [nzMinWidth]="100" [nzMaxWidth]="500"
                            [nzWidth]="col.width" (nzResizeEnd)="onResize($event, col.title)"
                            [nzShowSort]="col.sortTitle ? true : false"
                            [nzAlign]="col.title == 'Amount' || col.title == 'Fee' ? 'right' : 'left'"
                            [ngClass]="col.sortTitle ? 'sortableCol' : ''">
                            {{ col.title }}
                            <nz-resize-handle nzDirection="right">
                                <div class="resize-trigger"></div>
                            </nz-resize-handle>
                        </th>
                        <th *ngIf="col.title == 'Action' && (showActions &&  (canEditProgram || canDeleteProgram))"
                            [nzWidth]="col.width" nzAlign="center">
                            {{ col.title }}
                        </th>
                    </ng-container>
                </tr>
            </thead>
            <tbody *ngIf="!isDataLoaded">
                <tr *ngFor="let data of apiProgramsDataTable.data"
                    (dblclick)="canEditProgram ? showProgramDrawer(data):null">
                    <td nzEllipsis [nzTooltipTitle]="data.label?.length > 8 ? data.label : ''"
                        nzTooltipPlacement="bottomLeft" nz-tooltip>{{data.label}}</td>
                    <td>{{data.shortStartMonth +', '+ data.startYear}}</td>
                    <td>
                        {{data.shortEndMonth +', '+ data.endYear}}
                    </td>
                    <td>
                        <nz-radio-group [disabled]="!data.isVisible || !canEditProgram" [(ngModel)]="radioValue"
                            (ngModelChange)="makeProgramDefault($event)">
                            <label nz-radio [nzValue]="data.id"></label>
                        </nz-radio-group>
                    </td>
                    <td><nz-switch [disabled]="data.isDefault || !canEditProgram" [(ngModel)]="data.isVisible"
                            (ngModelChange)="updateProgramVisible(data)"></nz-switch></td>
                    <td><a class="link"
                            (click)="data.linked && data.linked > 0 ? navigateToActivity(data) : null">{{data.linked}}</a>
                    </td>

                    <td class="center" *ngIf="showActions && (canEditProgram || canDeleteProgram)">
                        <img *ngIf="canEditProgram" src="/assets/images/edit.png " class="mr-1 cursor"
                            (click)="showProgramDrawer(data)">
                        <img *ngIf="canDeleteProgram && data.linked == 0 && data.isDefault==false && data.isUncategorized == false"
                            class="cursor" src="/assets/images/delete.png" (click)="showDeleteConfirm(data) ">
                    </td>
                </tr>
            </tbody>
            <ng-container *ngIf="isDataLoaded">
                <tbody>
                    <tr *ngFor="let i of [].constructor(50)">
                        <ng-container
                            *ngFor="let i of [].constructor((showActions && (canEditProgram || canDeleteProgram)) ? 7 : 6)">
                            <td [nzAlign]="'left'" class="loading">
                                <div class="bar"></div>
                            </td>
                        </ng-container>
                    </tr>
                </tbody>
            </ng-container>
        </nz-table>
    </div>
</div>

<app-add-update-program *ngIf="isVisibleProgramDrawer" [selectedData]="selectedData"
    (hideProgramDrawer)="hideProgramDrawer($event)"></app-add-update-program>

<nz-modal [(nzVisible)]="deleteConfirmVisisble" nzCentered [nzMaskClosable]="false" (nzOnCancel)="handleCancel()">
    <div class="confirm-modal">
        <ng-container *nzModalContent class="cc">
            <div class="close-icon center">
                <i nz-icon nzType="delete" nzTheme="outline"></i>
            </div>
            <h4 class="confirm-modal-title center ">Are You Sure?</h4>
            <p class="confirm-modal-sub-title center ">Once <b>{{selectedData.label}}</b> is deleted, it
                cannot be recovered.</p>
        </ng-container>
        <div *nzModalFooter class=" d-flex justify-content-end">
            <button nz-button nzType="default" (click)="handleCancel()" class="default-btn width-100 ">Cancel</button>
            <button nz-button nzType="primary" (click)="deleteProgram()" class=" medium-btn delete-btn width-100"
                [nzLoading]="loading">Delete</button>
        </div>
    </div>
</nz-modal>